<template>
    <multiselect
        v-model="selected"
        :options="grades"
        :multiple="true"
        group-values="grades"
        group-label="group"
        :group-select="true"
        placeholder="Select grade level"
        track-by="grade"
        label="name"
        @input="update"
    ></multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    components: { Multiselect },

    props: {
        value: {
            type: String,
            default: '',
        }
    },

    mounted() {
    },

    computed: {
        selected: {
            get() {
                const vals = this.unstringify(this.selected_string);
                return this.arrayify(vals);
            },

            set(selected_array) {
                this.selected_string = this.stringify(selected_array);
            }
        }
    },

    data() {
        return {
            grades: [
                {
                    group: 'High School',
                    grades: [
                        { name: '12th', grade: 12 },
                        { name: '11th', grade: 11 },
                        { name: '10th', grade: 10 },
                        { name: '9th', grade: 9 },
                    ]
                },
                {
                    group: 'Middle School',
                    grades: [
                        { name: '8th', grade: 8 },
                        { name: '7th', grade: 7 },
                        { name: '6th', grade: 6 }
                    ]
                },
                {
                    group: 'Elementary School',
                    grades: [
                        { name: '5th', grade: 5 },
                        { name: '4th', grade: 4 },
                        { name: '3rd', grade: 3 },
                        { name: '2nd', grade: 2 },
                        { name: '1st', grade: 1 },
                        { name: 'Kindergarten', grade: 0 }
                    ]
                },
            ],

            selected_string: this.value,
        }
    },

    methods: {
        clear: function() {
            this.selected = [];
            this.store();
        },

        update: function(e) {
            this.$emit('input', this.stringify(this.selected));
        },

        /**
         * Converts the grade level string to an array
         * 
         * @param {*} grade_level_string 
         */
        unstringify: function(grade_level_string) {
            let result = [];
            let grade_levels = grade_level_string.split(',');

            grade_levels.forEach(element => {
                if ((/^K$/i).test(element)) {
                    result.push(0);
                } else if ((/^(?:[1-9]|1[0-2])$/).test(element)) {
                    result.push(parseInt(element));
                } else if ((/^K-(?:[1-9]|1[0-2])$/).test(element)) {
                    let match = element.match(/^K-([1-9]|1[0-2])$/);
                    for (let i=0; i<=parseInt(match[1]); i++) {
                        result.push(i);
                    }
                } else if ((/^([1-9]|1[0-2])-([1-9]|1[0-2])$/).test(element)) {
                    let match = element.match(/^([1-9]|1[0-2])-([1-9]|1[0-2])$/);
                    for (let i=parseInt(match[1]); i<=parseInt(match[2]); i++) {
                        result.push(i);
                    }
                }
            });
            return result;
        },

        /**
         * Converts an array of grade objects to a string
         * 
         * @param {*} grade_level_array 
         */
        stringify: function(grade_level_array) {
            if (grade_level_array === undefined) {
                return '';
            }

            if (!grade_level_array.length) {
                return '';
            }

            let result = grade_level_array.map((elem) => elem.grade);

            result = result.sort((a, b) => a - b);
                
            // Group array
            let x = [];
            let y = [];
            result.forEach(function(a, i) {
                if (y.length == 0) {
                    y = [a];
                } else if ((a - y.at(-1)) == 1) {
                    y.push(a);
                } else {
                    x.push(y);
                    y = [a];
                }
            });
            x.push(y);
            result = x;

            // Merge array into <MIN>-<MAX>
            x = [];
            result.forEach(function(a, i){
                if (a.length == 1) {
                    x.push(a[0]);
                } else {
                    x.push(`${a[0]}-${a[a.length - 1]}`);
                }
            });

            result = x.join(',').replace(/^0/, 'K');

            return result;
        },

        /**
         * Converts an array of grades (e.g. [0,1,2,3,4]) to an array
         * of the grade objects (e.g. [{grade: 0, name: 'Kindergarten'},...])
         * 
         * @param {*} grade_level_array 
         */
        arrayify: function(grade_level_array) {
            const grades = this.grades.flatMap((grp) => grp.grades);
            return grades.filter((elem) => grade_level_array.includes(elem.grade));
        }
    }
}
</script>